(function () {
  var COMBO_URL = '/collections/combo-2-for-500';

  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
  }

  function comboQty(cart) {
    var ids = window.MC_COMBO_IDS || [];
    var q = 0;
    cart.items.forEach(function (it) { if (ids.indexOf(it.product_id) > -1) q += it.quantity; });
    return q;
  }

  var toastTimer;
  function toast(html) {
    var t = document.getElementById('mc-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'mc-toast';
      t.className = 'mc-toast';
      t.setAttribute('role', 'status');
      document.body.appendChild(t);
    }
    t.innerHTML = html;
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 7000);
  }

  function addToCart(btn) {
    var id = btn.getAttribute('data-mc-add');
    if (!id || btn.disabled) return;
    btn.disabled = true;
    btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCount(cart.item_count);
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        var q = comboQty(cart);
        var msg;
        if (q > 0 && q % 2 === 1) {
          msg = '<strong>✓ Added to cart</strong><span>🎁 Add 1 more set → both for ৳500 + FREE Delivery!</span>' +
            '<div class="mc-toast__btns"><a href="' + COMBO_URL + '" class="mc-toast__btn">+ Add one more</a><a href="/cart" class="mc-toast__btn mc-toast__btn--ghost">View cart</a></div>';
        } else if (q > 0) {
          msg = '<strong>🎉 Combo unlocked!</strong><span>' + q + ' sets for ৳' + (q / 2 * 500) + ' + FREE Delivery</span>' +
            '<div class="mc-toast__btns"><a href="/cart" class="mc-toast__btn">View cart</a></div>';
        } else {
          msg = '<strong>✓ Added to cart</strong><div class="mc-toast__btns"><a href="/cart" class="mc-toast__btn">View cart</a></div>';
        }
        toast(msg);
        var quick = btn.closest('[data-mc-quick]');
        if (quick) {
          quick.querySelector('[data-mc-sizes]').hidden = true;
          quick.querySelector('[data-mc-open]').hidden = false;
        }
      })
      .catch(function () {
        toast('<strong>Sorry, could not add this.</strong><span>This size may be out of stock.</span>');
      })
      .then(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-mc-open]');
    if (open) {
      e.preventDefault();
      var quick = open.closest('[data-mc-quick]');
      quick.querySelector('[data-mc-sizes]').hidden = false;
      open.hidden = true;
      return;
    }
    var add = e.target.closest('[data-mc-add]');
    if (add) {
      e.preventDefault();
      addToCart(add);
    }
  });

  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function tick() {
    document.querySelectorAll('[data-mc-countdown]').forEach(function (el) {
      var end = Date.parse(el.getAttribute('data-mc-countdown'));
      if (isNaN(end)) return;
      var diff = Math.floor((end - Date.now()) / 1000);
      if (diff <= 0) {
        var box = el.closest('[data-mc-offer]');
        if (box) box.style.display = 'none';
        return;
      }
      var d = Math.floor(diff / 86400);
      var h = Math.floor((diff % 86400) / 3600);
      var m = Math.floor((diff % 3600) / 60);
      var s = diff % 60;
      el.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
    });
  }
  tick();
  setInterval(tick, 1000);
})();
